import React from 'react'

import * as classes from '../styles/carousel.module.sass'

const Carousel = ({ spacing = 15, defaultWidth = 360, children }) => {
    const widths = children.map(({ props }) => props.width || defaultWidth)
    const fullWidth = widths.reduce((a, b) => a + b) + children.length * spacing * 2
    return (
        <div className={classes.root}>
            <ul className={classes.wrapper} style={{ width: fullWidth }}>
                {children.map((child, i) => (
                    <li
                        key={i}
                        className={classes.item}
                        style={{
                            width: widths[i],
                            marginLeft: spacing,
                            marginRight: spacing,
                        }}
                    >
                        {child}
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default Carousel
